import { render, staticRenderFns } from "./hotel-scenic-detail.vue?vue&type=template&id=d4a5c734&scoped=true"
import script from "./hotel-scenic-detail.vue?vue&type=script&lang=js"
export * from "./hotel-scenic-detail.vue?vue&type=script&lang=js"
import style0 from "./hotel-scenic-detail.vue?vue&type=style&index=0&id=d4a5c734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a5c734",
  null
  
)

export default component.exports